import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Grid } from '@mui/material';
import { TablePagination, TextField } from '@mui/material';
import TopupsList from './TopupsList';
import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';
import AppBindStyles from '../../AppBindStyles';
import { addDays, isValid, startOfDay, subMonths } from 'date-fns';

const abEnvironment = new AbEnvironment();
const TopUpsQuery = graphql`
query TopUpsQuery($accountId: UUID, $startDate: Datetime, $endDate: Datetime, $first: Int, $offset: Int) {
  gettopuptransactions(accountid: $accountId, startts: $startDate, endts: $endDate, first: $first, offset: $offset) {
    totalCount
    ...TopupsList_cl
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
      //marginTop: 10,
    },
    flex: {
      flex: 1,
    }
});

class Topups extends Component {

  constructor(props) {
    super(props);


    let cToDate = new Date();
    let tDate = localStorage.getItem('cToDate');
    if (tDate != null) {
      cToDate = new Date(tDate);
    }
    //search todate would be start of next day.
    let searchToDateUtc = startOfDay(addDays(cToDate, 1)).toISOString();
    
    let cFromDate = new Date();
    let fDate = localStorage.getItem('cFromDate');
    if (fDate != null) {
      cFromDate = new Date(fDate);
    } else {
      cFromDate = subMonths(cToDate, 1);
    }
    //from date utc is start of today.
    let searchFromDateUtc = startOfDay(cFromDate).toISOString();

    this.state = {
      startDate: cFromDate,
      queryStartDateUtc: searchFromDateUtc,
      endDate: cToDate,
      queryEndDateUtc: searchToDateUtc,
      accountId: this.props.accountId,
      page: 0,
      rowsPerPage: 10,
    };  
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      page: 0,
    });
  };

  setFromDate(theDate) {
    if (isValid(theDate)) {
      let fromSearchDateUtc = startOfDay(new Date(theDate)).toISOString();
      localStorage.setItem('cFromDate', theDate);
      this.setState({ startDate: theDate, queryStartDateUtc : fromSearchDateUtc, page : 0 });
    }
  }
  
  setToDate(theDate) {
    if (isValid(theDate)) {
      let toSearchDateUtc = startOfDay(addDays(new Date(theDate), 1)).toISOString();
      localStorage.setItem('cToDate', theDate);
      this.setState({ endDate: theDate, queryEndDateUtc : toSearchDateUtc, page : 0 });
    }
  }

  handleChangePage = (event, page) => {
    this.setState({page: page});
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page : 0});
  }

  render() {
    const { isAuthenticated, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    if (!isAuthenticated() || needAssent()) { 
      return ( <Redirect to='/home' /> );
    }

    // Determine the offset
    let offset = 0;
    if (this.state.page > 0)
    {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;

    let totalCount = 0;

 
    return (
      <div className={classes.root}>
        <Grid container spacing={2} alignItems='center' style={AppBindStyles.searchContainerOnPaper}>
          <Grid item>
            <div style={AppBindStyles.datePickerField}>
            <DatePicker
              maxDateMessage={AppBindStyles.datePickerMessageMax}
              autoOk
              label="From date"
              value={this.state.startDate}
              onChange={(date) => this.setFromDate(date) }
              format="YYYY-MM-DD"
              disableFuture
              renderInput={(params) => <TextField {...params} />}
            />
            </div>
          </Grid>
          <Grid item>
            <div style={AppBindStyles.datePickerField}>
            <DatePicker
              autoOk
              label="To date"
              value={this.state.endDate}
              onChange={(date) => this.setToDate(date) }
              format="YYYY-MM-DD"
              disableFuture
              renderInput={(params) => <TextField {...params} />}
            />
            </div>
          </Grid>
        </Grid>
        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={TopUpsQuery}
          variables={{startDate: this.state.queryStartDateUtc,
                      endDate: this.state.queryEndDateUtc,
                      accountId: this.state.accountId,
                      first: first,
                      offset: offset}}
          render={({error, props})=> {
            if (error) {
              logError(error.message);
              return (
                <ServerError/>
              );
            } else if (props) {
              // Determine offset information
              totalCount = props.gettopuptransactions.totalCount;

              return (
                <div>
                  <TopupsList cl={props.gettopuptransactions} 
                               history={this.props.history}/>
                  <div style={AppBindStyles.paginationTableFooter}>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={totalCount}
                      rowsPerPage={this.state.rowsPerPage}
                      page={this.state.page}
                      backIconButtonProps={{
                        'aria-label': 'Previous Page',
                      }}
                      nextIconButtonProps={{
                        'aria-label': 'Next Page',
                      }}
                      onPageChange={this.handleChangePage}
                      onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />                        
                  </div>
                </div>
              )
            }
            return (
              <LoadingSpinner />
            );
          }}
        />
      </div>
    );
  }
}
  
Topups.propTypes = {
  classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(Topups);
